export default __webpack_public_path__ + "static/media/brakes.396e59f1.svg";